import React, { useEffect, useState } from "react";

import BillsContainer from "./BillsContainer";
import { RxHamburgerMenu } from "react-icons/rx";
import { useHistory } from "react-router-dom";

import SideBanner from "./SideBanner";
import { useGaEvents } from "./hooks/useGaEvents";
import { useMediaQuery } from "react-responsive";
import { useQuickBillContext } from "./hooks/useQuickBill";

import {
  Body,
  ButtonLogin,
  Container,
  Content,
  HeaderWrapper,
  IconMenuWrapper,
  IconTitle,
  Overlay,
  Title,
  TitleWrapper,
} from "./styles";

const BoletoRapido: React.FC = () => {
  const [showMenu, setShowMenu] = useState(false);
  const history = useHistory();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { handleClearData, document, selectedUnit } = useQuickBillContext();
  const { handleClickBack } = useGaEvents();

  const handleLogout = (): void => {
    handleClearData();
    handleClickBack(document, selectedUnit);
    history.push("/");
  };

  useEffect(() => {
    if (!document) {
      history.push("/");
    }
  }, [document, history]);

  return (
    <Container>
      <SideBanner showMenu={showMenu} setShowMenu={setShowMenu} />
      <Content>
        <HeaderWrapper>
          <TitleWrapper>
            {isMobile && (
              <IconMenuWrapper>
                <RxHamburgerMenu onClick={() => setShowMenu((prev) => !prev)} />
              </IconMenuWrapper>
            )}
            <IconTitle>//</IconTitle>
            <Title>Boleto rápido</Title>
          </TitleWrapper>
          <ButtonLogin onClick={handleLogout}>Home</ButtonLogin>
        </HeaderWrapper>
        <Body>
          {isMobile && showMenu && <Overlay />}
          <BillsContainer />
        </Body>
      </Content>
    </Container>
  );
};

export default BoletoRapido;
